var _rect, _rect2, _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClickingReleaseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.648438,
    width: 41.3828,
    height: 41.3828,
    rx: 5.55469,
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.648438,
    width: 41.3828,
    height: 41.3828,
    rx: 5.55469,
    stroke: "#EFF2F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 12.8633C9.6875 11.5257 10.7718 10.4414 12.1094 10.4414H31.4844C32.8219 10.4414 33.9062 11.5257 33.9062 12.8633V17.707C33.9062 19.0446 32.8219 20.1289 31.4844 20.1289H28.5579C27.6662 20.1289 26.9434 19.406 26.9434 18.5143V18.2606C26.9434 17.9121 26.7793 17.584 26.5005 17.3749L26.4278 17.3204C26.0288 17.0211 25.4705 17.0608 25.1178 17.4135C24.9298 17.6014 24.8242 17.8564 24.8242 18.1222V18.4164C24.8242 19.3622 24.0575 20.1289 23.1117 20.1289H21.7969H12.1094C10.7718 20.1289 9.6875 19.0446 9.6875 17.707V12.8633Z",
    fill: "#E4E3F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5488 20.1289H31.4844C32.8219 20.1289 33.9062 19.0446 33.9062 17.707V12.8633C33.9062 11.5257 32.8219 10.4414 31.4844 10.4414H12.1094C10.7718 10.4414 9.6875 11.5257 9.6875 12.8633V17.707C9.6875 19.0446 10.7718 20.1289 12.1094 20.1289H21.7969H24.8242",
    stroke: "#42296E",
    strokeWidth: 1.21094
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21381_17446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 18.256C22.0996 17.2774 22.4883 16.339 23.1803 15.6471C23.8722 14.9551 24.8106 14.5664 25.7892 14.5664C26.7677 14.5664 27.7062 14.9551 28.3981 15.6471C29.09 16.339 29.4788 17.2774 29.4788 18.256",
    stroke: "#42296E",
    strokeWidth: 1.21094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6681 28.7571L20.5878 25.2094C20.4026 24.8837 20.3537 24.4979 20.4519 24.1362C20.5501 23.7746 20.7873 23.4665 21.1119 23.2791C21.4364 23.0917 21.8218 23.0403 22.1841 23.1361C22.5464 23.2319 22.8561 23.4671 23.0456 23.7903L24.371 25.9189V18.256C24.371 17.8796 24.5205 17.5187 24.7867 17.2525C25.0528 16.9864 25.4137 16.8369 25.7901 16.8369C26.1665 16.8369 26.5274 16.9864 26.7935 17.2525C27.0597 17.5187 27.2092 17.8796 27.2092 18.256V22.2294C27.2092 21.853 27.3587 21.4921 27.6248 21.2259C27.8909 20.9598 28.2519 20.8103 28.6282 20.8103C29.0046 20.8103 29.3655 20.9598 29.6317 21.2259C29.8978 21.4921 30.0473 21.853 30.0473 22.2294V23.3646C30.0473 22.9883 30.1968 22.6273 30.4629 22.3612C30.7291 22.0951 31.09 21.9456 31.4664 21.9456C31.8427 21.9456 32.2037 22.0951 32.4698 22.3612C32.7359 22.6273 32.8854 22.9883 32.8854 23.3646V25.9189C32.8854 27.6218 32.3178 28.7571 32.3178 28.7571",
    stroke: "#42296E",
    strokeWidth: 1.21094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21381_17446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1641,
    height: 18.1641,
    fill: "white",
    transform: "translate(17.5586 12.8633)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickingReleaseIcon);
export default __webpack_public_path__ + "static/media/clicking_release_icon.196a96ee4e91789d847aae1bb5998cec.svg";
export { ForwardRef as ReactComponent };